import Api from './index'
import { ITipResponse } from './types/tips'

export const getTips = () => Api<ITipResponse>('GET', 'support/tips')
